module.exports = __webpack_public_path__ + "img/Yogurt-Nan-200x132.6d84f38c.jpg";